import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "quick-6",
  "use": "quick-6-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"quick-6\">\n<path d=\"M27 29H3C1.89543 29 1 28.1046 1 27L1 3C1 1.89543 1.89543 1 3 1H21.186L29 8.81395V27C29 28.1046 28.1046 29 27 29Z\" stroke=\"#151515\" stroke-width=\"1.5\" />\n<path d=\"M10.6 10.1H19.4V17.1228C19.4 17.4171 19.2561 17.6928 19.0146 17.8611L15 20.6592L10.9854 17.8611C10.7439 17.6928 10.6 17.4171 10.6 17.1228V10.1Z\" stroke=\"#007F41\" stroke-width=\"2.2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol